<script>
  import Vue from "vue";
  import { Chart } from "chart.js";
  import { Line, mixins } from "vue-chartjs";
  const { reactiveProp } = mixins;

  export default {
    extends: Line,
    mixins: [reactiveProp],
    props: {
      type: Number
    },
    data: function() {
      return {
        options: {
          maintainAspectRatio: false,
          // cornerRadius: 200,
          legend: {
            display: false
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data){
                // var label = data.datasets[tooltipItem.datasetIndex].label || '';
                // // if (label) {
                // //   label += ': ';
                // // }
                // label += Math.round(tooltipItem.yLabel * 100) / 100;
                return `${tooltipItem.yLabel.toFixed(4)}${app.type === 2? 'kWh' : 'm³'}`;
              }
            },
          },
          scales: {
            yAxes: [
              {
                display: false,
                ticks: {
                  // beginAtZero: true
                }
              }
            ],
            xAxes: [
              {
                // maxBarThickness: 20,
                // scaleShowLabels : true,
                drawBorder: false,
                gridLines: {
                  display: false,
                  lineWidth: 0
                },
                ticks: {
                  autoSkip: true,
                  maxTicksLimit: 20,
                  maxRotation: 0,
                  minRotation: 0
                }
              }
            ]
          }
        }
      };
    },
    mounted() {
      this.renderChart(this.chartData, this.options);
    }
  };
</script>

<style scoped lang="less">
    canvas{
        max-height: 235px;
        width: 100%;
    }
</style>
